import React from 'react'

import clubLogo from '../images/club_logo.png'
import { clearAuthSession, getCompanyLogoUrl } from '../config/session'

export function SideBar() {
  const currentUser = sessionStorage.getItem('role')
  const resolvedClubLogo = getCompanyLogoUrl() || clubLogo

  return (
    <nav className="pcoded-navbar menu-dark navbar-default brand-default drp-icon-style1 menu-item-icon-style1 active-default title-default">
      <div className="navbar-wrapper">
        <div className="text-center">
          <a className="" href="/dashboard">
            <img
              style={{ width: '60%', marginTop: '20px' }}
              src={resolvedClubLogo}
              alt="activity-user"
            />
          </a>
          {/* <a className="mobile-menu" id="mobile-collapse" href="/dashboard">
            <span></span>
          </a> */}
        </div>
        <div className="navbar-content datta-scroll">
          <div className="scrollbar-container ps">
            <ul id="nav-ps-next" className="nav pcoded-inner-navbar    -flush">
              <li className="nav-item pcoded-menu-caption  ">
                <label>Acessos</label>
              </li>
              <li className=" ">
                <a className="nav-link" target="" href="/dashboard">
                  <span className="pcoded-micon">
                    <i className="feather icon-home"></i>
                  </span>
                  <span className="pcoded-mtext">Inicio</span>
                </a>
              </li>

              {currentUser !== 'default' && (
                <li className=" ">
                  <a className="nav-link" target="" href="/user/create">
                    <span className="pcoded-micon">
                      <i className="feather icon-users"></i>
                    </span>
                    <span className="pcoded-mtext">Cadastrar Usuários</span>
                  </a>
                </li>
              )}
              {currentUser !== 'default' && (
                <li className=" ">
                  <a className="nav-link" target="" href="/approvers">
                    <span className="pcoded-micon">
                      <i className="feather icon-user-check"></i>
                    </span>
                    <span className="pcoded-mtext">Cadastrar Aprovadores</span>
                  </a>
                </li>
              )}
              {/* <li className=" ">
                <a className="nav-link" target="" href="/visitors">
                  <span className="pcoded-micon">
                    <i className="feather icon-users"></i>
                  </span>
                  <span className="pcoded-mtext">Visitantes</span>
                </a>
              </li> */}
              {currentUser !== 'default' && (
                <li className=" ">
                  <a className="nav-link" target="" href="/monitoring">
                    <span className="pcoded-micon">
                      <i className="feather icon-pie-chart"></i>
                    </span>
                    <span className="pcoded-mtext">Monitoramento</span>
                  </a>
                </li>
              )}
              {currentUser !== 'default' && (
                <li className=" ">
                  <a className="nav-link" target="" href="/reporting">
                    <span className="pcoded-micon">
                      <i className="feather icon-file-text"></i>
                    </span>
                    <span className="pcoded-mtext">Relatórios</span>
                  </a>
                </li>
              )}
            </ul>
            <ul id="nav-ps-next" className="nav pcoded-inner-navbar    -flush">
              <li className="nav-item pcoded-menu-caption  ">
                <label></label>
              </li>
              <li className=" ">
                <a className="nav-link" target="" href="/user/edit/me">
                  <span className="pcoded-micon">
                    <i className="feather icon-user"></i>
                  </span>
                  <span className="pcoded-mtext">Meus dados</span>
                </a>
              </li>

              <li className="disabled">
                <a
                  className="nav-link"
                  target=""
                  href="/"
                  onClick={() => {
                    clearAuthSession()
                  }}
                >
                  <span className="pcoded-micon">
                    <i className="feather icon-power"></i>
                  </span>
                  <span className="pcoded-mtext">Sair</span>
                </a>
              </li>
            </ul>
            <div className="ps__rail-x">
              <div className="ps__thumb-x"></div>
            </div>
            <div className="ps__rail-y">
              <div className="ps__thumb-y"></div>
            </div>
          </div>
        </div>
      </div>
    </nav>
  )
}
